import { ListRow } from '@brain/ui'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import {
  Archive,
  CalendarClock,
  CheckSquare,
  ChevronRight,
  Gavel,
  Handshake,
  Inbox,
  Settings,
  Users,
} from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { ContainerList } from '../../components/ContainerList.tsx'
import { NotificationBell } from '../../components/NotificationBell.tsx'
import { inboxQuery } from '../../lib/hooks.ts'

export const Route = createFileRoute('/_app/para')({ component: Para })

/** Mobile "PARA" tab (§20.3): everything the rail offers on desktop. */
function Para() {
  const { t } = useTranslation()
  const inbox = useQuery(inboxQuery())
  const links = [
    { to: '/inbox', icon: Inbox, label: t('nav.inbox'), count: inbox.data?.length },
    { to: '/tasks', icon: CheckSquare, label: t('nav.tasks') },
    { to: '/meetings', icon: CalendarClock, label: t('nav.meetings') },
    { to: '/entscheidungen', icon: Gavel, label: t('nav.decisions') },
    { to: '/personen', icon: Users, label: t('nav.people') },
    { to: '/zusagen', icon: Handshake, label: t('nav.commitments') },
    { to: '/bereiche', icon: ChevronRight, label: t('nav.areas') },
    { to: '/ressourcen', icon: ChevronRight, label: t('nav.resources') },
    { to: '/archiv', icon: Archive, label: t('nav.archive') },
    { to: '/einstellungen', icon: Settings, label: t('nav.settings') },
  ] as const
  return (
    <div className="min-w-0 flex-1 overflow-y-auto">
      <div className="flex justify-end px-4 pt-3">
        <NotificationBell variant="header" />
      </div>
      <div className="flex flex-col px-2 pt-2">
        {links.map((l) => (
          <Link key={l.to} to={l.to} className="block">
            <ListRow
              className="min-h-12"
              leading={<l.icon size={18} strokeWidth={1.9} />}
              title={l.label}
              trailing={
                'count' in l && l.count ? <span className="text-[12px] text-meta">{l.count}</span> : undefined
              }
            />
          </Link>
        ))}
      </div>
      <ContainerList kind="project" />
    </div>
  )
}
